import Player from '../components/Player';
import GameScene from './Game';

export default class GameLevelTest extends GameScene {
    constructor() {
        super({key: 'GameLevelTest'});
    }

    init() {
        super.init(
            {
                'id': 1,
                'bg':'game_bg_01',
                'score': 100,
                'globalPopulationSupply' : -1,
                'players': [
                    { 'id': 'Player', 'type': 'human', 'color': '0xfff00' },
                    { 'id': 'Neutral', 'type': 'neutral', 'color': '0x7c7c7c' },
                    { 'id': 'Computer1', 'type': 'computer', 'color': '0x991717' }
                ],
                'nodes': [
                    { 'id': '1', 'x': 350, 'y': 300, 'player': 'Computer1' },
                    { 'id': '2', 'x': 300, 'y': 600, 'player': 'Neutral', 'options': { 'initPopulation': 5 } },
                    { 'id': '3', 'x': 150, 'y': 700, 'player': 'Player', 'options': { 'initPopulation': 5 } }
                ],
                'paths': [
                    { 'node1': '1', 'node2': '2' },
                    { 'node1': '2', 'node2': '3' }
                ],
                'image':'game_image_info_move_units',
                'computerStrategy': undefined
            }
        );

        this.score = 100;

        // Players
        const player = new Player('Player', this, Player.humanType, 0xfff00);
        const neutral = new Player('Neutral', this, Player.neutralType, 0x7c7c7c);
        const computer1 = new Player('Computer1', this, Player.computerType, 0x991717);

        // Nodes
        this.getNodes().add('1', 400, 100, computer1, {});
        this.getNodes().add('2', 300, 300, neutral, {initPopulation:5});
        this.getNodes().add('3', 100, 400, neutral, {initPopulation:5});
        this.getNodes().add('4', 450, 600, neutral, {initPopulation:5});
        this.getNodes().add('5', 150, 700, player, {initPopulation:5});
        
        // Paths
        this.getPaths().add(this.getNodes().byId('1'), this.getNodes().byId('2'), []);
        this.getPaths().add(this.getNodes().byId('2'), this.getNodes().byId('3'), []);
        this.getPaths().add(this.getNodes().byId('2'), this.getNodes().byId('4'), []);
        this.getPaths().add(this.getNodes().byId('3'), this.getNodes().byId('5'), []);
        this.getPaths().add(this.getNodes().byId('4'), this.getNodes().byId('5'), []);
    }

    public create() {
        super.create();
    }
}